import { render } from "./HeroiconsOutlineCloudDownload.vue?vue&type=template&id=bf572e4a"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCloudDownload.vue"]])

export default __exports__